/**
 * Alineado con backend helpers (p. ej. applyTicketCloseSideEffects isTruthy).
 */
export function isSettingTruthy(value) {
  const s = String(value ?? "")
    .trim()
    .toLowerCase();
  return s === "1" || s === "true" || s === "enabled" || s === "yes";
}

/**
 * GET /settings puede llegar como array plano o envuelto (proxies / versiones).
 */
export function normalizeSettingsList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  if (data && Array.isArray(data.settings)) return data.settings;
  return [];
}
